import { render, staticRenderFns } from "./MovieDetails.vue?vue&type=template&id=bac1ecba&scoped=true&"
import script from "./MovieDetails.vue?vue&type=script&lang=js&"
export * from "./MovieDetails.vue?vue&type=script&lang=js&"
import style0 from "./MovieDetails.vue?vue&type=style&index=0&id=bac1ecba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac1ecba",
  null
  
)

export default component.exports